import Vue from 'vue'
import Vuex from 'vuex'
import store from 'store'

import inv from './inv'

Vue.use(Vuex)

const getDefaultState = () => ({
  user: null,
  documentsRead: [],
  cgaValue: null,
  // État CGA du dernier portefeuille consulté : { portefeuille, isMandatory,
  // isUserAccepted }. Alimenté par getCgaValue, mis à jour par setCgaValue —
  // sert au getter cgaOk qui conditionne les onglets Questions/Notifications.
  cgaStatus: null,
})

export default new Vuex.Store({
  state: getDefaultState(),
  mutations: {

    USER (state, payload) {
      state.user = payload
    },

    DOCUMENTS_READ (state, payload) {
      state.documentsRead = payload
    },

    DOCUMENTS_READ_ADD (state, payload) {
      if (state.documentsRead.indexOf(Number(payload)) === -1) { state.documentsRead.push(Number(payload)) }
    },

    LOGOUT (state) {
      delete Vue.api.defaults.headers.common['Authorization']
      store.remove('token')
      Object.assign(state, getDefaultState())
    },

    SET_CGA_VALUE (state, value) {
      console.log('value' + value)
      state.cgaValue = value
    },

    CGA_STATUS (state, payload) {
      state.cgaStatus = payload
    },

  },
  getters: {
    // Règle métier : questions et notifications ne sont visibles que lorsque les
    // CGA du portefeuille sont acceptées — ou lorsqu'il n'y a pas de CGA
    // obligatoires. Tant que l'état n'est pas chargé (ou concerne un autre
    // portefeuille), on masque.
    cgaOk: (state) => (portefeuille) =>
      state.cgaStatus !== null &&
      String(state.cgaStatus.portefeuille) === String(portefeuille) &&
      (!state.cgaStatus.isMandatory || state.cgaStatus.isUserAccepted === true),
  },
  actions: {

    async getUser ({ commit }, token = null) {
      if (token) {
        store.set('token', token)
      } else {
        token = store.get('token')
      }
      if (!token) return
      Vue.api.defaults.headers.common['Authorization'] = 'Bearer ' + token

      const data = await Vue.api.get('/user')
      commit('USER', data.user)
      commit('DOCUMENTS_READ', data.documentsRead)
    },

    addDocument ({ commit }, id) {
      commit('DOCUMENTS_READ_ADD', id)
    },

    // Le nom d'utilisateur n'est plus envoye aux routes CGA : le serveur le derive de
    // la session JWT (il etait controlable par le client). Les actions acceptent
    // toujours { user, id } de leurs appelants, mais ne transmettent que l'id.
    async setCgaValue ({ commit, state }, payload) {
      const { id, val } = payload
      await Vue.api.post(`/user/save-cga-json`, {
        id: id,
        value: val,
      })
      commit('SET_CGA_VALUE', val)
      // Répercute l'acceptation sur l'état courant : les onglets conditionnés
      // (questions, notifications) apparaissent sans rechargement.
      if (state.cgaStatus && String(state.cgaStatus.portefeuille) === String(id)) {
        commit('CGA_STATUS', { ...state.cgaStatus, isUserAccepted: val === true })
      }
    },

    async getCgaValue ({ commit }, { id }) {
      try {
        const response = await Vue.api.get(`/user/getCgaValue?param2=${encodeURIComponent(id)}`)
        const data = await response.cgaValue
        if (data !== undefined) {
          commit('CGA_STATUS', {
            portefeuille: id,
            isMandatory: data.isMandatory === true,
            isUserAccepted: data.isUserAccepted === true,
          })
          return data
        } else {
          throw new Error('La réponse ne contient pas de champ "cga".')
        }
      } catch (error) {
        console.error('Erreur lors de la récupération de la valeur cga:', error)
        throw error
      }
    },

    // Contenu du PDF, demande a part et seulement a l'ouverture de la fenetre
    // d'acceptation : getCgaValue le rapatriait a chaque depliage de portefeuille
    // pour ne s'en servir que dans ce cas.
    async getCgaDocument ({ commit }, { id }) {
      return Vue.api.get(
        `/user/getCgaDocument?param2=${encodeURIComponent(id)}`,
        { responseType: 'arraybuffer' }
      )
    },
  },
  modules: {
    inv,
  },
})
